import styled from 'styled-components';

import { MODAL_CONTENT_PADDING } from '@/styles.ts';

/** Flex child that fills a {@link ModalGridContent} column and clips overflow to descendants. */
export const WidgetSiteTabbedFlexFill = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

/** Shared inset around site panel body (tab panel and single-site paths). */
export const WidgetSiteTabbedPanelPadding = styled.div`
  padding: ${MODAL_CONTENT_PADDING};
`;

/** Single-site path: same padding as tab panels, with local vertical scroll. */
export const WidgetSiteTabbedPanelScroll = styled(WidgetSiteTabbedPanelPadding)`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;
